import { render, staticRenderFns } from "./LiveLivingOption.vue?vue&type=template&id=b68bd85c&"
import script from "./LiveLivingOption.vue?vue&type=script&lang=js&"
export * from "./LiveLivingOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports